import { Button, IconButton, Snackbar, Stack } from '@mui/material'
import CopyToClipboardButton from 'components/buttons/CopyToClipboardButton';
import Link from 'components/buttons/Link';
import Icon from 'components/icons/Icon'
import Text from 'components/labels/Text';
import Box from 'components/layout/box/Box';
import Checkbox from 'components/toggle/checkbox/Checkbox';
import React, { useEffect, useState } from 'react'
import { UserService } from 'services/UserService';
import { UseBusyIndicatorStore, Update as BusyUpdate } from 'stores/BusyIndicatorStore';


export const AdminConsentLink = (props: any) => {
    const [isAdminConsentLinkedRequired, setIsAdminConsentLinkedRequired] = useState<boolean>(false);
    const [adminConsentLink, setAdminConsentLink] = useState<string>(null);
    const userService = new UserService();

    useEffect(() => {
      loadAdminLinkAsync();
    }, []);
    
    const loadAdminLinkAsync = async() => {
        const adminLink = await userService.getDmsAdminConsentLinkAsync();
        setAdminConsentLink(adminLink);
    }

    
    return (
          <Box>
            <Checkbox
              onChange={() => setIsAdminConsentLinkedRequired(!isAdminConsentLinkedRequired)} 
              checked={isAdminConsentLinkedRequired} 
              label="Need admin consent?"/>
              {isAdminConsentLinkedRequired && <Box>
                {!adminConsentLink && <Text>Loading...</Text>}
                {adminConsentLink && <>
                  <Link target='_blank' href={adminConsentLink}>Consent Link</Link> 
                  <CopyToClipboardButton content={adminConsentLink}/>
                </>}
            </Box>}
          </Box>
    )
}

